﻿import { createSlice } from "@reduxjs/toolkit";

const initialState = { error: null };

export const applicationErrorSlice = createSlice({
  name: "applicationError",
  initialState,
  reducers: {
    setApplicationError(state, { payload }) {
      state.error = payload;
    },
    resetApplicationError(state) {
      state.error = null;
    },
  },
});
